// PORTE DE VERSION AU DÉMARRAGE (A18, 07/10/2026).
//
// Bug du téléphone de Benjamin : après un déploiement, un joueur qui revient
// lançait l'ANCIENNE version (page d'entrée du précache du service worker),
// incompatible avec les règles du jour : lecture refusée, chargement sans fin.
// sw.js sert désormais la page réseau d'abord ; en filet, au démarrage, on
// compare la version qui tourne à celle que le serveur publie (version.json,
// écrit au build, cf. vite.config.mjs) et on recharge UNE fois si elles
// diffèrent. Anti-boucle : la version pour laquelle on a déjà rechargé est
// notée en sessionStorage ; jamais deux rechargements pour la même.
export const CLE_RECHARGE = "animax-version-recharge";
export const DELAI_MS = 3000;

/** Faut-il recharger ? Pur, testé. */
export function decision({ courante, servie, dejaRecharge }) {
  if (!servie || !courante || servie === courante) return "ok";
  if (dejaRecharge === servie) return "deja-recharge";
  return "recharger";
}

export async function verifierVersion({
  courante,
  url,
  fetchFn = globalThis.fetch,
  storage = null,
  recharger = () => window.location.reload(),
  delaiMs = DELAI_MS,
}) {
  let servie = null;
  try {
    const ctrl = typeof AbortController === "function" ? new AbortController() : null;
    const minuterie = setTimeout(() => ctrl?.abort(), delaiMs);
    const rep = await fetchFn(`${url}?t=${Date.now()}`, { cache: "no-store", signal: ctrl?.signal });
    clearTimeout(minuterie);
    if (rep.ok) servie = (await rep.json())?.version || null;
  } catch {
    return "injoignable"; // hors ligne ou lent : on garde la version qui tourne
  }
  let deja = null;
  try {
    deja = storage?.getItem(CLE_RECHARGE) ?? null;
  } catch {
    /* stockage bloqué */
  }
  const d = decision({ courante, servie, dejaRecharge: deja });
  if (d === "recharger") {
    try {
      storage?.setItem(CLE_RECHARGE, servie);
    } catch {
      return "stockage-bloque"; // sans anti-boucle sûr, on ne recharge pas
    }
    console.info(`[version] ${courante} => ${servie} : rechargement`);
    recharger();
  }
  return d;
}
